import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const RequireAdmin = () => {
  try {
    const raw = localStorage.getItem('adminSession');
    if (!raw) return <Navigate to="/admin/login" replace />;

    const session = JSON.parse(raw);
    if (!session?.adminRole) return <Navigate to="/admin/login" replace />;

    return <Outlet />;
  } catch {
    return <Navigate to="/admin/login" replace />;
  }
};

export default RequireAdmin;
